
import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { RetentionManagementContent } from '@/components/admin/certificates/RetentionManagementContent';

export default function CertificatesRetention() {
  return (
    <AdminLayout>
      <RetentionManagementContent />
    </AdminLayout>
  );
}
